import React from "react";
import { Box, CssBaseline } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"; // Import React Router components
import NavBar from './layout/NavBar';
import Home from './layout/Header';
import ScrollToTop from "./pages/ScrollToTop";
import './App.css';
import AboutUs from "./pages/AboutUs";
import Footer from "./layout/Footer";
import ContactUs from "./pages/ContactUs";
import OverView from "./pages/OverView";
import SupportPage from "./pages/Support";
import OurServices from "./pages/OurServices";
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from "./pages/TermsAndConditions";
import Careers from "./pages/Careers";
import SeoManager from "./layout/SeoManager";

// Define theme
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      light: '#1e293b',
      main: '#0f172a',
      dark: '#020617',
      contrastText: '#f8fafc',
    },
    secondary: {
      light: '#5eead4',
      main: '#14b8a6',
      dark: '#0f766e',
      contrastText: '#022c22',
    },
    tertiary: {
      main: '#f97316',
    },
    background: {
      default: '#f8fafc',
      paper: '#ffffff',
    },
    text: {
      primary: '#0f172a',
      secondary: '#475467',
    },
  },
  typography: {
    fontFamily: '"Space Grotesk", "Poppins", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 600,
    fontWeightBold: 700,
    h1: { fontWeight: 700, letterSpacing: '-0.02em' },
    h2: { fontWeight: 700, letterSpacing: '-0.02em' },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    subtitle1: { color: '#475467' },
    body1: { color: '#475467' },
  },
  shape: {
    borderRadius: 18,
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 999,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 24,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 24,
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      <Box className="app-shell">
        <Router>
          <SeoManager />
          <ScrollToTop />
          <NavBar />
          <Box component="main" className="main-section">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/expertize" element={<OverView />} />
              <Route path="/support" element={<SupportPage />} />
              <Route path="/our-services" element={<OurServices />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsAndConditions />} />
              <Route path="/careers" element={<Careers />} />
            </Routes>
          </Box>
          <Footer />
        </Router>
      </Box>
    </ThemeProvider>
  );
}

export default App;
